import { useCallback } from "react";
import { fetchAllPatientenDetailsPage } from "../apiCalls/usersApi";
import useInfiniteList from "./useInfiniteList";

export const PATIENT_DETAILS_PAGE_SIZE = 24;

const getPatientDetailsKey = (item) =>
  item?.user_id || item?.id || item?.email || item?.full_name;

const useInfinitePatientenDetails = (search = "") => {
  const fetchPage = useCallback(
    (page, pageSize) => fetchAllPatientenDetailsPage(pageSize, page, search),
    [search]
  );

  return useInfiniteList({
    fetchPage,
    getItemKey: getPatientDetailsKey,
    pageSize: PATIENT_DETAILS_PAGE_SIZE,
    resetKey: search,
  });
};

export default useInfinitePatientenDetails;
